import type { ProductionRun } from "./models";

type WorkOrderDisplayRun = Pick<
  ProductionRun,
  "workOrderNo" | "planWorkOrderMatch" | "productName"
>;

export const isInternalWorkOrderNo = (value: string | null | undefined) =>
  /^(?:PLAN|QA)-/iu.test(value?.trim() ?? "");

export const hasVisibleWorkOrder = (
  run: Pick<WorkOrderDisplayRun, "workOrderNo" | "planWorkOrderMatch">,
) =>
  run.planWorkOrderMatch !== "MISSING" &&
  run.planWorkOrderMatch !== "AMBIGUOUS" &&
  !isInternalWorkOrderNo(run.workOrderNo);

export const operatorProductionSourceLabel = (run: WorkOrderDisplayRun) =>
  hasVisibleWorkOrder(run) ? `İş emri ${run.workOrderNo}` : "Plandan üretim";

export const productionIdentityLabel = (run: WorkOrderDisplayRun) =>
  hasVisibleWorkOrder(run) ? run.workOrderNo : run.productName;

export const operatorNotificationMessage = (item: {
  message: string;
  workOrderNo?: string | null;
  productName?: string | null;
}) => {
  const technicalWorkOrder = item.workOrderNo ?? "";
  if (!isInternalWorkOrderNo(technicalWorkOrder)) return item.message;
  const visibleSubject = item.productName ?? "Planlı üretim";
  return item.message
    .replace(`${technicalWorkOrder} numaralı iş`, `${visibleSubject} işi`)
    .replace(technicalWorkOrder, visibleSubject);
};
